export default "__VITE_ASSET__BdJ2K58R__"